export default __webpack_public_path__ + "static/media/Group 1722.637080f4.png";